import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, PlusCircle, Clock, Store, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Home' },
  { path: '/add', icon: PlusCircle, label: 'Log Meal' },
  { path: '/history', icon: Clock, label: 'History' },
  { path: '/restaurants', icon: Store, label: 'Places' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 border-t"
      style={{
        background: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderColor: '#E8E6E0',
        paddingBottom: 'env(safe-area-inset-bottom, 8px)'
      }}
    >
      <div className="flex items-center justify-between px-4 py-2 max-w-lg mx-auto">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = location.pathname === path;
          return (
            <button
              key={path}
              data-testid={`nav-${label.toLowerCase().replace(' ', '-')}`}
              onClick={() => navigate(path)}
              className="flex flex-col items-center gap-0.5 py-1 px-3 min-w-[56px] rounded-xl transition-all touch-active"
              style={{
                background: isActive ? 'rgba(0, 90, 141, 0.08)' : 'transparent',
              }}
            >
              <Icon
                className="w-6 h-6"
                style={{ color: isActive ? '#005A8D' : '#5E646E' }}
                strokeWidth={isActive ? 2.2 : 1.8}
              />
              <span
                className="text-xs font-medium"
                style={{
                  color: isActive ? '#005A8D' : '#5E646E',
                  fontFamily: 'DM Sans, sans-serif'
                }}
              >
                {label}
              </span>
            </button>
          );
        })}
        <button
          data-testid="nav-logout"
          onClick={logout}
          className="flex flex-col items-center gap-0.5 py-1 px-3 min-w-[56px] rounded-xl transition-all touch-active"
        >
          <LogOut className="w-6 h-6" style={{ color: '#5E646E' }} strokeWidth={1.8} />
          <span className="text-xs font-medium" style={{ color: '#5E646E', fontFamily: 'DM Sans, sans-serif' }}>
            Logout
          </span>
        </button>
      </div>
    </nav>
  );
}
